import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { AuthenticationContext } from 'parog-web/contexts/authentication-context';
import Button from 'ui-kit/components/button';
import Checkbox from 'ui-kit/components/checkbox';
import LabeledInput from 'ui-kit/components/labeled-input';

interface Args {
  context: AuthenticationContext;
  onDismiss: () => void;
}
export default class CnamServicesAccessFormAuthenticationModifyPracticeLocationComponent extends Component<Args> {
  @tracked shouldUpdatePracticeLocation = false;

  onSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    this.args.context.shouldUpdatePracticeLocation =
      this.shouldUpdatePracticeLocation;
    await this.args.context.transitionTo();
  };

  <template>
    <div data-test-modify-practice-location-step>
      <form
        class='ui form'
        id='dmp-access-form-authentication-state-form'
        {{on 'submit' this.onSubmit}}
      >
        <div class='two fields'>
          <div class='field'>
            <div class='field'>
              <LabeledInput
                @labelName="Situation d'exercice"
                @value={{@context.practiceLocation}}
                @isReadOnly={{true}}
                @dataTestInput='practiceLocation'
              />
            </div>
          </div>
          <div class='field'>
            <Checkbox
              @labelName="Modifier la situation d'exercice"
              @checked={{this.shouldUpdatePracticeLocation}}
              @onChange={{fn (mut this.shouldUpdatePracticeLocation)}}
              @dataTestInput='updatePracticeLocation'
            />
          </div>
        </div>

        <div class='form-buttons'>
          <Button
            type='button'
            class='ui fluid form-button'
            {{on 'click' @onDismiss}}
          >
            Annuler
          </Button>
          <Button
            type='submit'
            data-test-button='submit-dmp-access-form'
            class='ui fluid primary form-button'
          >
            Continuer
          </Button>
        </div>
      </form>
    </div>
  </template>
}
